// frontend/src/pages/AuthCallbackPage.jsx
import React, { useEffect } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useAuthContext } from '../contexts/AuthContext'

const AuthCallbackPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { login, loading: authLoading } = useAuthContext() // Get login and authLoading

  useEffect(() => {
    if (authLoading) {
      return
    }

    const token = searchParams.get('token')
    const error = searchParams.get('error')

    if (error) {
      console.error('OAuth Error on callback:', decodeURIComponent(error))
      const encodedError = encodeURIComponent(
        decodeURIComponent(error) || 'Autenticazione fallita. Riprova.'
      )
      navigate(`/login?error=${encodedError}`, { replace: true })
    } else if (token) {
      login(token)
      navigate('/chat', { replace: true })
    } else {
      console.error('AuthCallbackPage: No token and no error in URL parameters.')
      navigate(
        '/login?error=Si_è_verificato_un_errore_di_autenticazione_imprevisto._Token_mancante.',
        { replace: true }
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams, navigate, login, authLoading])

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        padding: '20px',
        textAlign: 'center',
      }}
    >
      <h2>Elaborazione Autenticazione</h2>
      <p>Attendere prego mentre ti colleghiamo in modo sicuro...</p>
      {/* <div className="spinner"></div> */}
    </div>
  )
}

export default AuthCallbackPage
